import styled from 'styled-components';
export const IconTitle = styled.p`
  font-weight: 700;
  font-size: 20px;
`;